import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { ProblemAgitation } from './components/ProblemAgitation';
import { SolutionReveal } from './components/SolutionReveal';
import { RutaSystem } from './components/RutaSystem';
import { Deliverables } from './components/Deliverables';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#FFF9F3] font-sans text-[#2D3436] selection:bg-[#2ABFBF]/30" data-id="element-0">
      {/* Navigation / Logo Area (Simple) */}
      <nav className="w-full py-4 px-6 bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-1">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-2">
          <span className="font-serif font-bold text-xl text-[#1B2A4A]" data-id="element-3">
            La Ruta Clara
          </span>
          <button className="text-sm font-semibold text-[#1B2A4A] hover:text-[#2ABFBF] transition-colors" data-id="element-4">
            Comprar ahora
          </button>
        </div>
      </nav>

      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <OpeningLead data-id="element-7" />
        <ProblemAgitation data-id="element-8" />
        <SolutionReveal data-id="element-9" />
        <RutaSystem data-id="element-10" />
        <Deliverables data-id="element-11" />
        <ClosingSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}